module.exports = __webpack_public_path__ + "img/universe-landing-2.d8df19c7.jpg";